import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ModalContent, Text } from '@met/react-components';

const ConfirmationModal = ({ onCancelClick, onConfirmClick, headerMessage, bodyMessage }) => {
  return (
    <Modal hidden={false} centered={true} size={'md'}>
      <ModalContent>
        <ModalHeader>
          {headerMessage}
        </ModalHeader>
        <ModalBody>
          <Text>{bodyMessage}</Text>
        </ModalBody>
        <ModalFooter>
          <Button secondary onClick={onCancelClick}>Cancel</Button>
          <Button primary onClick={onConfirmClick}>Confirm</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;